import { render, staticRenderFns } from "./liveLike.vue?vue&type=template&id=3580bcbc&scoped=true&"
import script from "./liveLike.vue?vue&type=script&lang=js&"
export * from "./liveLike.vue?vue&type=script&lang=js&"
import style0 from "./liveLike.vue?vue&type=style&index=0&id=3580bcbc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3580bcbc",
  null
  
)

component.options.__file = "liveLike.vue"
export default component.exports